import { createReducer, on } from '@ngrx/store';
import { IReportingState } from './reporting.state';
import {
  generateReport,
  generateReportFailure,
  generateReportSuccess,
} from './reporting.actions';

export const initialState: IReportingState = {
  damageEntry: { generating: false },
  claimHandling: { generating: false },
};

export const reportingReducer = createReducer(
  initialState,
  on(generateReport, (state, { reportType }) => ({
    ...state,
    [reportType]: { generating: true },
  })),
  on(generateReportSuccess, (state, { reportType }) => ({
    ...state,
    [reportType]: { generating: false },
  })),
  on(generateReportFailure, (state, { reportType }) => ({
    ...state,
    [reportType]: { generating: false },
  }))
);
